import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import AgoraRTC from "agora-rtc-sdk-ng";
import useAppDispatch from '../../../../hooks/useAppDispatch';
import useAppAccessor from '../../../../hooks/useappAccessor';
import { changeAudio, changeVideo } from "../../components/streamControls/controls.actions";
import close from '../../../../assets/icons/close.svg';
const MicSelector = (props: any) => {
  const dispatch = useAppDispatch();
    const [cameraDevices, setCameraDevices] = useState<MediaDeviceInfo[]>([]);
    const [selectedMic, setSelectedMic] = useState('');
    const [selectedDeviceId, setSelectedDeviceId] = useState<string | null>(null);
    const { getControls } = useAppAccessor();
    const { newVideoStream, newAudioStream } = getControls();
    const { getUserData } = useAppAccessor();
    const { language } = getUserData();


    const handleSelectDevice = (deviceId: string) => {
      setSelectedDeviceId(deviceId);
      handleMicChange(deviceId);
      props.toggleVisible();
      setTimeout(() => {
        props.toggleVisible();
        } , 100);
    };

    const handleMicChange = async (deviceId: string) => {
      setSelectedMic(deviceId);
      const stream = await navigator.mediaDevices.getUserMedia({ audio: { deviceId } });
      const audioTrack = stream.getAudioTracks()[0];
      if (audioTrack) {
        dispatch(changeAudio(deviceId));
      }
    }

    useEffect(() => {
        const getCameraDevices = async () => {
          const devices = await AgoraRTC.getMicrophones();
          setCameraDevices(devices);
          if(newAudioStream){
            setSelectedMic(newAudioStream);
            setSelectedDeviceId(newAudioStream);
          }
          if (devices.length > 0) {
            // setSelectedMic(devices[0].deviceId);
            // setSelectedDeviceId(devices[0].deviceId);
          }
        };
    
        getCameraDevices();
      }, []);

  return (
    <div className="audio-selector-container">
      {(
        <div className="dropdown" id={'micSelector'}>
          <button onClick={() => {
            props.toggleVisible();
          }} style={{ position: 'absolute', top: '10px', right: '10px' }}>
              <img
                    src={close}
                    alt="close"
                    height={24}
                    width={24}
                    style={{ height: "24px" , margin: '3px' }}
                    className="cursor-pointer"
                  ></img>
          </button>
          <h3>{language['select_microphone']}</h3>
          <ul>
            {cameraDevices.map((device) => (
              <li  onClick={() => handleSelectDevice(device.deviceId)}
              style={{ cursor: 'pointer' }}
              key={device.deviceId}
              >{selectedDeviceId === device.deviceId ? '• ' : ''}{device.label}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MicSelector;
